import { render, staticRenderFns } from "./CheckEnclosure.vue?vue&type=template&id=372d8080&lang=pug"
import script from "./CheckEnclosure.vue?vue&type=script&lang=ts"
export * from "./CheckEnclosure.vue?vue&type=script&lang=ts"
import style0 from "./CheckEnclosure.vue?vue&type=style&index=0&id=372d8080&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports